import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const JobNameInputI18n = {
  configuration: { namespace: I18nNamespace.JOB_NAME_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.jobName,
    placeholder: dictionary.jobName,
    validationMaxLengthError: dictionary.validationMaxLengthError,
    validationRequiredError: dictionary.validationRequiredError,
  },
};
